import type {NetworkResponse} from "../../fd/Types";

export function parseQuery(endpoint: string): Map<string, string> {
    return parseEndpoint(endpoint).params;
}

export function parseEndpoint(endpoint: string):{ path: string, params: Map<string, string>, hash?:string } {
	const url = new URL(endpoint, "https://crm.fake.com");
	const sp = url.searchParams;
	const m:Map<string, string> = new Map();

	sp.forEach((v, k) => {
		m.set(k, v);
	});
	return {
		path: url.pathname,
		hash: url.hash,
		params: m
	};
}

export type EndpointFunc = (q:Map<string, string>, body?:any) => any;